import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { AuthResponseDTO } from 'src/app/dto/responses/AuthResponseDTO';
import { Observable } from 'rxjs';
import { StorageService } from '../storage/storage.service';
import { REFRESH_TOKEN_KEY, TOKEN_KEY } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  public $isAuthenticated = signal<boolean | null>(null)

  private router = inject(Router);
  private api = inject(ApiService);
  private storage = inject(StorageService);

  public async init() {
    let isAuth = (await this.getToken()) != null;
    this.$isAuthenticated.set(isAuth);
  }

  public async setToken(token: string): Promise<void> {
    this.storage.set(TOKEN_KEY, token);
    this.$isAuthenticated.set(true);
  }

  public async setRefreshToken(token: string): Promise<void> {
    await this.storage.set(REFRESH_TOKEN_KEY, token);
  }

  public async getToken(): Promise<string | null> {
    return await this.storage.get<string | null>(TOKEN_KEY);
  }

  public async getRefreshToken(): Promise<string | null> {
    return await this.storage.get(REFRESH_TOKEN_KEY);
  }

  public setInvalidTokens() {
    this.setToken('X');
  }
  public setInvalidRefreshToken() {
    this.setRefreshToken('X');
  }

  public logout(): void {
    this.removeTokens();
    this.router.navigate(['/home'] , { replaceUrl: true });
  }

  public refreshToken(refreshToken: string): Observable<AuthResponseDTO> {
    return this.api.post<AuthResponseDTO>(`/auth/refresh-token`, { refreshToken });
  }

  public removeTokens(): void {
    this.storage.remove(TOKEN_KEY);
    this.storage.remove(REFRESH_TOKEN_KEY);
    this.$isAuthenticated.set(false);
  }
}
